<template>
<!--此部分根据设计自动生成，手动修改节点标记daltag="manual"属性，则该节点及子节点不会被自动生成代码覆盖，如发现其他需要调整框架情形请联系:alex.c@daline.com.cn-->
<div id="Unitsubmissionmonitoring" style="width:100vw">
  <div id="a87b69f2">
    单元提交监控
  </div>
  <el-table id="f8b9b94c" :data="tbd_f8b9b94c" stripe="" border="">
    <el-table-column prop="a874ed1f" label="项目名称">
    </el-table-column>
    <el-table-column prop="a358af74" label="作者">
    </el-table-column>
    <el-table-column prop="a35768ac" label="提交时间">
    </el-table-column>
    <el-table-column prop="a4a837a6" label="布置时间">
    </el-table-column>
    <el-table-column prop="f423cd79" label="耗时">
    </el-table-column>
    <el-table-column prop="abff708c" label="重启次数">
    </el-table-column>
    <el-table-column prop="a4640861" label="运行时间">
    </el-table-column>
  </el-table>
</div>
</template>
<script>
//此文件根据设计自动生成编写框架，请在指定位置编写逻辑代码，如发现框架需要调整的情形请联系:alex.c@daline.com.cn
//在此注释下方添加自定义import
//在此注释下方添加自定义函数
//此注释下方为自动引用部分，请不要修改
export default{
  data(){
    return{
    tbd_f8b9b94c:[]
      //在此注释下方添加自定义变量
    }
  },
  mounted(){
  },
  computed:{
  },
  watch:{
  },
  methods:{
    //在此注释下方添加自定义函数或事件
  }
}
</script>
<style>
/*此部分根据设计自动生成，自定义样式追加到该部分结尾处*/
#a87b69f2{
  padding-top:100px;
}
#a87b69f2{
  text-align:center;
  color:#1c1c1c;
  font-size:30px;
  font-family:PingFang SC;
}
#f8b9b94c{
  width:1323px;
  margin-top:30px;
  margin-left:163px;
  padding-bottom:2503px;
}
#f8b9b94c{
  display:inline-block;
  vertical-align: middle;
}
/*在此注释下方添加自定义样式*/
</style>
